export default __webpack_public_path__ + "static/blob5-3ca1e6cc3029b72d6b6a0de55069e0d3.svg";